import { render, staticRenderFns } from "./Woveon.vue?vue&type=template&id=674677bf&"
import script from "./Woveon.vue?vue&type=script&lang=js&"
export * from "./Woveon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports